import styled from 'styled-components'
import { COLORS } from '@enums/colors'
import { spacing } from '@util/spacing'

export const InputContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    margin: 2rem 0 1rem;
    padding: 0;
`

export const InputLabel = styled.label`
    position: absolute;
    background-color: ${COLORS.white};
    top: 0;
    left: 0;
    z-index: 1;
    font-size: 1rem;
    padding: 0 0.5rem;
    box-sizing: border-box;

    pointer-events: none;
    transform: translate(10px, 18px) scale(1);
    transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
`

export const InputBox = styled.input<{ isValid: boolean }>`
    width: 100%;
    padding: ${spacing.s16};
    border-radius: 4px;
    border: 1px solid ${COLORS.border};
    font-size: 1rem;
    background-color: ${COLORS.white};
    box-sizing: border-box;

    &:focus + label, &:not(:placeholder-shown) + label {
        transform: translate(0, -8px) scale(0.75);
    }
    &:focus {
        outline: none;
        border: 1px solid ${props => props.isValid ? COLORS.black : COLORS.energeticPink };
        -webkit-font-smoothing: antialiased;
    }
`

export const InputInvalidInformation = styled.div`
    position: relative;
    box-sizing: border-box;
    width: 100%;
`